"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepDelete = void 0;
const tslib_1 = require("tslib");
const get_1 = tslib_1.__importDefault(require("lodash/get"));
const isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
const findIndexes_1 = require("./findIndexes");
const array_helper_1 = require("./array.helper");
function deepDelete(array, item, options) {
    // Passed input is not an array
    if (!(0, isArray_1.default)(array))
        return array;
    const match = (0, array_helper_1.extractMatch)(options);
    const copy = (0, get_1.default)(options, 'copy', true);
    const multiple = (0, get_1.default)(options, 'multiple', false);
    for (const eachItem of (0, isArray_1.default)(item) ? item : [item]) {
        // Find the index of the item to delete
        const indexes = multiple
            ? (0, findIndexes_1.findIndexes)(array, eachItem, match)
            : [array.findIndex((i) => (0, array_helper_1.isSame)(i, eachItem, match))];
        // item not found
        if (!indexes.length || indexes[0] === -1)
            return array;
        // delete item at index
        for (const index of indexes) {
            // delete the item
            array.splice(index, 1);
        }
    }
    return copy ? [...array] : array;
}
exports.deepDelete = deepDelete;
